import { Link } from 'react-router-dom';
import { featuredVideos } from '@/mocks/homeData';
import VideoCard from '@/pages/home/components/VideoCard';

export default function FeaturedSection() {
  if (featuredVideos.length === 0) return null;

  const mainFeature = featuredVideos[0];
  const sideFeatures = featuredVideos.slice(1, 3);
  const gridFeatures = featuredVideos.slice(3, 7);

  return (
    <section className="py-10 md:py-14 bg-background-100/50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="mb-8">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">精选推荐</h2>
          <p className="text-sm text-foreground-600 mt-1">编辑精选的优质视频内容</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-5 mb-6">
          <div className="lg:col-span-2">
            <VideoCard video={mainFeature} size="large" />
          </div>
          <div className="flex flex-col gap-4 md:gap-5">
            {sideFeatures.map((video) => (
              <VideoCard key={video.id} video={video} />
            ))}
          </div>
        </div>

        {gridFeatures.length > 0 && (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {gridFeatures.map((video) => (
              <VideoCard key={video.id} video={video} />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}